import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Polls a turbo_stream endpoint that replaces this controller's host element.
// When the response swaps in non-polling content (which omits this
// controller), the element disconnects and polling stops automatically.
//
// Values:
//   url (String) – endpoint returning a turbo_stream that replaces
//                  containing element with the current status partial
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.schedule();
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  schedule() {
    this.timer = setTimeout(() => this.check(), 2500);
  }

  async check() {
    if (!this.element.isConnected) return;
    try {
      await get(this.urlValue, { responseKind: "turbo-stream" });
    } catch (_) {
      // Retry for network or server errors
    }
    if (this.element.isConnected) {
      this.schedule();
    }
  }
}
